import { graphql } from "../generated";

export const BOOKMARK = graphql(`
  mutation Bookmark($ids: [ID!]!) {
    bookmark(ids: $ids) {
      id
      isBookmarked
    }
  }
`);
